import store from './store';

export const setReports = store.create.set('reports');
